import { Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { MgSupplierItemClimate } from '@retail/products/types';
import { useProductsTFunction } from '@retail/products/i18n';
import { EmissionTypography } from './EmissionTypography';

interface Props {
  data: MgSupplierItemClimate['data'];
}

export const TotalEmissionsContent = ({ data }: Props) => {
  const t = useProductsTFunction();

  const phaseValues = [
    data.extractedFromEpd?.epdDataGwpA?.epdGwpTotalA1A3,
    data.extractedFromEpd?.epdDataGwpA?.epdGwpTotalA4,
    data.extractedFromEpd?.epdDataGwpA?.epdGwpTotalA5,
    data.extractedFromEpd?.epdDataGwpB?.epdGwpTotalB1B7,
    data.extractedFromEpd?.epdDataGwpC?.epdGwpTotalC1C4,
    data.extractedFromEpd?.epdDataGwpD?.epdGwpTotalD,
  ].filter((value): value is number => value != null);

  const totalEmissionsValue = phaseValues.length
    ? phaseValues.reduce((sum, value) => sum + value, 0)
    : undefined;

  const negativeTotalEmission = totalEmissionsValue !== undefined && totalEmissionsValue < 0;

  return (
    <Stack p={1} borderBottom="1px solid" borderColor="divider">
      <Stack flexDirection="row" gap={4} alignItems="center">
        <Typography variant="h6">{t('products.mgItem.gwp.total')}:</Typography>
        <EmissionTypography value={totalEmissionsValue} />
      </Stack>
      {negativeTotalEmission && (
        <Typography variant="subtitle2">{t('products.mgItem.gwp.negativeTotal')}</Typography>
      )}
    </Stack>
  );
};
